export const PRACTICE_AREAS = [
  'Medicina',
  'Psicologia',
  'Fisioterapia',
  'Dentista',
  'Dermatologia',
  'Desenvolvedor de Software',
  'Design',
  'Odontologia',
  'Enfermagem',
  'Farmácia',
  'Nutrição',
  'Biomedicina',
  'Veterinária',
  'Fonoaudiologia',
  'Terapia Ocupacional',
  'Educação Física',
]

export const POPULAR_AREAS = ['Medicina', 'Psicologia', 'Fisioterapia']

export const CRM_UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
]

export const MEDICAL_SITUATIONS = [
  { id: 'enrolled_brazil', label: 'Estou cursando medicina no Brasil' },
  { id: 'graduated_no_crm', label: 'Me formei, mas ainda não recebi o CRM' },
  { id: 'other', label: 'Outro' },
] as const

export const GRADUATION_MONTHS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

export const LANDING_CHANNELS = [
  { id: 'google', label: 'Google ou outra busca' },
  { id: 'instagram', label: 'Instagram' },
  { id: 'indication', label: 'Indicação de um amigo' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'other', label: 'Outro' },
] as const
